import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Shield, Lock } from 'lucide-react';
import SunsetBackground from '../components/ui/SunsetBackground';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const BlockedPage = () => (
  <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
    <SunsetBackground variant="dark" />
    <div className="bg-white/95 backdrop-blur-xl rounded-2xl p-12 max-w-md text-center shadow-2xl shadow-black/30 border border-white/20 relative z-10" data-testid="blocked-page">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-red-500/20 to-orange-500/20 flex items-center justify-center mx-auto mb-6 border border-red-500/30">
        <Lock className="w-10 h-10 text-red-500" />
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
        Access Denied
      </h1>
      <p className="text-gray-600 mb-2">
        Your IP address is not authorized to access this portal.
      </p>
      <p className="text-gray-500 text-sm">
        Contact your administrator to whitelist your IP address.
      </p>
      <div className="mt-8 pt-6 border-t border-gray-200">
        <div className="flex items-center justify-center gap-2 text-gray-400">
          <Shield className="w-4 h-4" />
          <span className="text-xs">MyAiAnalysis — Secured Access</span>
        </div>
      </div>
    </div>
  </div>
);

export const useIPCheck = () => {
  const [blocked, setBlocked] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        // Use /api/security/check - this endpoint is NOT skipped by IP middleware
        // If IP is blocked, middleware returns 403 before endpoint runs
        const response = await axios.get(`${BACKEND_URL}/api/security/check`);
        console.log('IP Check passed:', response.data);
        setBlocked(false);
      } catch (error) {
        if (error.response?.status === 403) {
          console.log('IP Check: Access Denied (403)');
          setBlocked(true);
        } else {
          // Other errors (network, etc.) — don't block, let normal flow handle
          console.log('IP Check: Error (non-403)', error.message);
        }
      } finally {
        setChecking(false);
      }
    };
    check();
  }, []);

  return { blocked, checking };
};

export default BlockedPage;
